/* eslint-disable @typescript-eslint/no-explicit-any */
import { ELECTRON_MODE } from "@constants";
import { useSnapshot } from "valtio";

import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { store } from "@store";

import { getCatalogueCarte } from "@helpers/fetcher";

export default function useElectronPreload(): void {
    const dispatch = useDispatch();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const shopDetail: any = JSON.parse(localStorage.getItem("shopDetail")!);
    const { middlewareApiUrl } = useSnapshot(store);

    useEffect(() => {
        if (process.env.REACT_APP_MODE === ELECTRON_MODE) {
            (window as RendererWindow).electronAPI.onMidnightNotification(
                () => {
                    console.log(
                        "Midnight notification received, getting new catalog card..."
                    );
                    getCatalogueCarte(dispatch, shopDetail, middlewareApiUrl);
                }
            );

            (window as RendererWindow).electronAPI?.checkKioskModeEvent();
        }
    }, []);
}
